import { PAGES_WITH_AUTH_HEADER } from "../../constants";

export const authHeaderEnabled = (currentPageType, pbConfig) => {
  const isAheadNxtEnabled = pbConfig?.general?.aheadNxtEnabled || false;
  return isAheadNxtEnabled && PAGES_WITH_AUTH_HEADER.includes(currentPageType);
};
